import React from "react";
import { Flex, Text, Button } from "@fluentui/react-northstar";
import { useTranslation } from "react-i18next";

import { PageHeader } from "../../page-header/pageHeader";

import { useAudioTestEndedFeedbackStyles } from "./AudioTestEndedFeedback.styles";
import { AudioTestEndedFeedbackProps } from "./AudioTestEndedFeedback.types";

export const AudioTestEndedFeedback: React.FC<AudioTestEndedFeedbackProps> = ({
  runTestAgain,
  resultsUnclearClick,
  resultsClearClick,
}) => {
  const audioTestEndedFeedbackStyles = useAudioTestEndedFeedbackStyles();
  const { t } = useTranslation();

  return (
    <Flex
      vAlign="stretch"
      hAlign="center"
      gap="gap.large"
      column
      styles={audioTestEndedFeedbackStyles.container}
    >
      <Flex vAlign="center">
        <PageHeader
          headerStyles={audioTestEndedFeedbackStyles.clarityHeader}
          headerContent={t("AUDIO_TEST_SURVERY_QUESTION")}
        />
      </Flex>
      <Flex.Item push>
        <Flex
          column
          hAlign="center"
          vAlign="end"
          gap="gap.medium"
          styles={audioTestEndedFeedbackStyles.buttonGroup}
        >
          <Button
            className="focus-button"
            tabIndex={0}
            onClick={resultsClearClick}
            fluid
            styles={audioTestEndedFeedbackStyles.testClarityPromptButton}
            content={
              <Text
                content={<>{t("YES")}</>}
                size="large"
                weight="semibold"
                align="center"
              />
            }
            data-testid="ResultsWereClearButton"
          />
          <Button
            className="focus-button"
            tabIndex={1}
            onClick={resultsUnclearClick}
            fluid
            styles={audioTestEndedFeedbackStyles.testClarityPromptButton}
            content={
              <Text
                content={<>{t("AUDIO_TEST_SURVEY_BUTTON_NOT_QUITE")}</>}
                size="large"
                weight="semibold"
                align="center"
              />
            }
            data-testid="ResultsWereUnclearButton"
          />
          <Button
            className="focus-button"
            tabIndex={2}
            onClick={runTestAgain}
            fluid
            styles={audioTestEndedFeedbackStyles.runTestAgain}
            content={
              <Text
                content={<>{t("RUN_TEST_AGAIN")}</>}
                size="large"
                weight="semibold"
                align="center"
              />
            }
            data-testid="runTestAgain"
          />
        </Flex>
      </Flex.Item>
    </Flex>
  );
};
